import { Link } from "react-router-dom";

const UserColumns = (navigate) => {
  return [
    {
      dataKey: "firstName",
      name: "Name",
      width: "200px",
      minWidth: "200px",
      align: "left",
      sortable: true,
      render: (value, rowData) => (
        <Link
          style={{ color: "inherit" }}
          to={`/admin-console/${rowData.id}/details`}
        >
          {`${value} ${rowData.surname}`}
        </Link>
      ),
    },
    {
      dataKey: "email",
      name: "Email",
      width: "250px",
      minWidth: "250px",
      align: "left",
      sortable: true,
    },
    {
      dataKey: "role",
      name: "Role",
      width: "200px",
      minWidth: "200px",
      align: "left",
      sortable: true,
    },
    {
      dataKey: "serviceGroup",
      name: "Service Group",
      width: "200px",
      minWidth: "200px",
      align: "left",
      sortable: true,
    },
    {
      dataKey: "employmentStatus",
      name: "Employment Status",
      width: "150px",
      minWidth: "150px",
      align: "left",
      sortable: true,
    },
  ];
};

export default UserColumns;
